module.exports = ".song-info-avatar {\n  display: block;\n  max-width: 100% !important;\n  height: 50px ;\n}\n\n@media screen and (max-width: 640px) {\n  .song-info-avatar {\n  height: 50px ;\n}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/song-info/song-info-avatar-next-song/song-info-avatar-next-song.component.css
// module id = ./src/app/player/song-info/song-info-avatar-next-song/song-info-avatar-next-song.component.css
// module chunks = main